import { IRentsyncSettings } from '@llws/lift-entity-interfaces';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IApiResponse, IMetaResponse } from '@/shared';
import { IAction } from '@/shared/interfaces/store-base';
import syndicationSettings from '@/shared/services/syndication-settings';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/syndication-api/rentsync_settings';
const listViewName: string = '';
const showLogging: boolean = false;

const alias = 'rs';

const defaultGetListFilters: IQueryCommandOptions = {
  alias,
  relations: [
    {
      path: 'contentBlocks',
      alias: 'cb',
    },
    {
      path: 'cb.contentBlockTemplate',
      alias: 'cbt',
    },
  ],
  where: [
    {
      field: 'feedKey',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'partnerKey',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'buildingId',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'suiteTypeId',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
  ],
  limit: 999,
};

const defaultGetSingleFilters: IQueryCommandOptions = {
  alias,
  relations: [
    {
      path: 'contentBlocks',
      alias: 'cb',
    },
  ],
  where: [
    {
      field: 'feedKey',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'partnerKey',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'buildingId',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
    {
      field: 'suiteTypeId',
      value: 'null',
      operator: 'null',
      condition: 'and',
      notOperator: false,
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IRentsyncSettings>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'client-syndication-settings/'

  state: {
    ...base.state,

    autoOnSettings: [] as IApiResponse<IRentsyncSettings, IMetaResponse> | [],
    // custom state
    // ...{
    // },
  },

  getters: {
    ...base.getters,

    // custom getters
    ...{
      autoOnSettings: (state: any) => [
        ...state.autoOnSettings && state.autoOnSettings.data
          ? state.autoOnSettings.data
          : [],
      ],
    },
  },

  mutations: {
    ...base.mutations,

    // custom mutations
    ...{
      setAutoOnSettings: (
        state: any,
        payload: IApiResponse<IRentsyncSettings[], IMetaResponse>| IRentsyncSettings[],
      ) => {
        state.autoOnSettings = Array.isArray(payload)
          ? { ...state.autoOnSettings && state.autoOnSettings, ...{ data: payload } }
          : payload;
      },
    },
  },

  actions: {
    ...base.actions,
    async getAutoOn(ctx: IAction<any>) {
      const result = await syndicationSettings.getAutoOnSettings();
      ctx.commit('setAutoOnSettings', result);
    },
  },
};
